import styled from 'styled-components';

export const TextInfo = styled.div`
  margin-right: 7px;
  padding: 10px;  
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const TalentWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ withoutAdditionalActions }) => `2fr 2fr 2fr ${withoutAdditionalActions ? '' : '35px'}`};
  border-radius: 4px;
  max-width: 100%;  
  margin-bottom: 5px;
  box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.table.shadow};
`;



// WEBPACK FOOTER //
// ./src/components/talents-list/talent/styled-components.js